import { EvolysProvider } from "@evolys/ui";
import { Notifications } from "@mantine/notifications";
import { AuthProvider } from "@evolys/auth";

const API_BASE_URL = import.meta.env.VITE_API_URL ?? "http://localhost:5000";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <EvolysProvider>
      <Notifications position="top-right" />
      <AuthProvider apiBaseUrl={API_BASE_URL}>{children}</AuthProvider>
    </EvolysProvider>
  );
}
